import { render } from "./Code.vue?vue&type=template&id=290a38da&scoped=true"
import script from "./Code.vue?vue&type=script&lang=ts"
export * from "./Code.vue?vue&type=script&lang=ts"

import "./Code.vue?vue&type=style&index=0&id=290a38da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-290a38da"

export default script